export default __webpack_public_path__ + "static/media/twitter-icon.5a540f9a.svg";